import type { ReactNode } from "react";

/** Read-only "petit encart" used on the temporal projection page to render a
 *  single field value as a bordered card — the exact visual language as the
 *  synthesised problem list (see ProblemListDisplay), so scalar, array and
 *  empty fields all read uniformly. Presentational only. */
export function ValueCard({
  children,
  muted = false,
}: {
  children: ReactNode;
  muted?: boolean;
}) {
  return (
    <div className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2">
      <div
        className={[
          "text-sm font-medium break-words",
          muted ? "text-slate-400 italic" : "text-slate-900",
        ].join(" ")}
      >
        {children}
      </div>
    </div>
  );
}
